module.exports = __webpack_public_path__ + "static/media/icon_fitness.514504d4.svg";